export default import.meta.ROLLDOWN_FILE_URL_RrU_ViWoYsKLextjJEd0Tg